export const ButtonSizeEnum = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large"
}